import {DocsLink,DEVHUBLink} from "@src/config/env";
export {DocsLink,DEVHUBLink,RepuationLink} from "@src/config/env";

export const PolicyLink = `${DocsLink}resources/privacy-policy/`;

export const GithubBaseLink = "https://github.com/primus-labs";
export const GithubLink = `${GithubBaseLink}/zkFHE-Network-Docs`
export const PORDocsLink = `${GithubBaseLink}/PoR-docs/blob/main/README.md`;
export const DVCDocsLink = `${GithubBaseLink}/DVC-Intro`;

export const DiscordLink = "https://discord.com/invite/pdrNxRrApX";

export const ZKAttestationLink =
  "https://chromewebstore.google.com/detail/pado/oeiomhmbaapihbilkfkhmlajkeegnjhe?pli=1";

export const Developer = [
  {
    title: "Github",
    footerTitle: "Github",
    hasIcon: true,
    link: GithubBaseLink,
  },
  {
    title: "Docs",
    footerTitle: "Docs",
    hasIcon: true,
    link: DocsLink,
  },
  {
    title: "Dev Hub",
    footerTitle: "Dev Hub",
    hasIcon: true,
    link: DEVHUBLink,
  },
  {
    title: "Research",
    footerTitle: "Research",
    hasIcon: true,
    link: `${GithubBaseLink}/research-and-exploration`,
  },
];

export const Discover = [
  {
    title: "Proof-of-Reserves",
    footerTitle: "Proof-of-Reserves",
    hasIcon: false,
    localLink: "/por",
  },
  {
    title: "Use Cases",
    footerTitle: "Use Cases",
    hasIcon: false,
    localLink: "/#Use-Cases",
  },
  {
    title: "Blog",
    footerTitle: "Blog",
    hasIcon: false,
    localLink: "/blog",
  },
  
  
  {
    title: "Ecosystem",
    footerTitle: "Ecosystem",
    hasIcon: false,
    localLink: "/ecosystem",
  },
  
  {
    title: "Data Verification",
    footerTitle: "Data Verification",
    hasIcon: false,
    localLink: "/data-verification",
  },
];



export const JoinUsLinks = {
  x: "https://x.com/primus_labs",
  discord: DiscordLink,
  medium: "https://medium.com/@primuslabs",
  telegram: "https://t.me/primuslabs",
};

export const Community = [
  {
    title: "Join Discord",
    footerTitle: "Join Discord",
    hasIcon: true,
    link: JoinUsLinks.discord,
  },
  {
    title: "Follow X",
    footerTitle: "Follow X",
    hasIcon: true,
    link: JoinUsLinks.x,
  },
  // {
  //   title: " Join Telegram",
  //   footerTitle: " Join Telegram",
  //   hasIcon: true,
  //   link: JoinUsLinks.telegram,
  // },
];


export const Resources = [
  {
    title: "Brand Assets",
    footerTitle: "Brand Assets",
    hasIcon: true,
    link: "https://drive.google.com/drive/folders/14a45d1OSgiLoWAesOnYbqHFdlodBpbzJ?usp=drive_link",
  },
  {
    title: "Privacy Policy",
    footerTitle: "Privacy Policy",
    hasIcon: true,
    link: PolicyLink,
  },
];


export const NavMenus = [
  {
    title: "Developer",
    subMenus: Developer,
  },
  {
    title: "Discover",
    subMenus: Discover,
  },
  {
    title: "Community",
    subMenus: Community,
  },
  {
    title: 'Contact Us',
    link: 'https://calendly.com/fubiao_xia/30min',
    subMenus: [],
  }
];
